module.exports = __webpack_public_path__ + "img/dxjy.02e949fe.png";